import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 32px;
  padding: 24px 16px;
  background: ${({ theme }) => theme.palette.primary.blue50};

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    padding: 48px;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    flex-direction: row-reverse;
    gap: 144px;
    margin-top: 48px;
  }
`;

export const DescriptionTitle = styled.h2`
  font-size: ${16 / 16}rem;
  font-family: "Poppins", sans-serif;
  color: ${(props) => props.theme.palette.greyscale.grey800};
  font-weight: 600;
  margin-top: 32px;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${24 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-top: 0;
  }
`;

export const DescriptionParagraph = styled.p`
  margin-top: 24px;
  margin-bottom: 16px;
  font-size: ${12 / 16}rem;
  line-height: ${30 / 16}rem;
  color: ${(props) => props.theme.palette.greyscale.grey600};
  font-family: "Inter", sans-serif;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    font-size: ${16 / 16}rem;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin-bottom: 32px;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
`;

export const Logo = styled.img`
  max-width: 50%;
`;
export const ImagesWrapper = styled.div`
  position: relative;
  max-width: 480px;
  margin: 0 auto;
`;

export const DesktopUpHideWrapper = styled.div`
  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: none;
  }
`;

export const CentralImageWrapper = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 24px auto 0;
  overflow: hidden;
  border-radius: 0 0 50% 50%;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    max-width: 600px;
  }
`;

export const CentralImage = styled.img`
  width: 100%;
  aspect-ratio: 3 / 2; 
  object-fit: cover;
  object-position: center;
  display: block;

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    aspect-ratio: 3 / 2;
  }
`;

export const DesktopCardsWrapper = styled.div`
  margin-bottom: 32px;
  gap: 12px;
  justify-content: flex-start;
  display: none;

  @media (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    display: flex;
  }
`;

export const AdvantageCardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const AnnunciationLink = styled.a`
  > button {
    max-width: 600px;
  }
`;
